import React from "react";
import Box from "@amzn/meridian/box";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Heading from "@amzn/meridian/heading";
import Loader from "@amzn/meridian/loader";
import {FormattedMessage} from "react-intl";

const SECTIONS = {
    ORDER_SNAPSHOT: {
        titleId: "qcDashboard.orderSnapshot",
        titleDefault: "Order Snapshot",
        fields: [
            {key: "totalActive", labelId: "qcDashboard.totalActive", labelDefault: "Total Active"},
            {key: "onTime", labelId: "qcDashboard.onTime", labelDefault: "On-time"},
            {key: "atRisk", labelId: "qcDashboard.atRisk", labelDefault: "At Risk"},
            {key: "late", labelId: "qcDashboard.late", labelDefault: "Late"},
            {key: "returns", labelId: "qcDashboard.returns", labelDefault: "Returns"},
            {key: "rejected", labelId: "qcDashboard.rejected", labelDefault: "Rejected"},
        ]
    },
    UTR: {
        titleId: "qcDashboard.utr",
        titleDefault: "UTR (Under The Roof)",
        fields: [
            {key: "unassigned", labelId: "qcDashboard.unassigned", labelDefault: "Unassigned"},
            {key: "pickerAssigned", labelId: "qcDashboard.pickerAssigned", labelDefault: "Picker Assigned"},
            {key: "picking", labelId: "qcDashboard.picking", labelDefault: "Picking"},
            {key: "picked", labelId: "qcDashboard.picked", labelDefault: "Picked"},
            {key: "packing", labelId: "qcDashboard.packing", labelDefault: "Packing"},
            {key: "packed", labelId: "qcDashboard.packed", labelDefault: "Packed"},
            {key: "staged", labelId: "qcDashboard.staged", labelDefault: "Staged"},
        ]
    },
    OTR: {
        titleId: "qcDashboard.otr",
        titleDefault: "OTR (On The Road)",
        fields: [
            {key: "packagesOnRoad", labelId: "qcDashboard.onRoad", labelDefault: "On Road"},
            {key: "packagesDelivered", labelId: "qcDashboard.delivered", labelDefault: "Delivered"},
        ]
    }
};

const MAX_ROWS = Math.max(...Object.values(SECTIONS).map(s => s.fields.length));

const HEADER_STYLE = {
    background: "linear-gradient(135deg, #1a3a4a, #2c7a7b)",
};

const getValue = (widgetDataMap, section, key) => {
    const sectionData = widgetDataMap[section];
    if (sectionData && sectionData[key] && sectionData[key].data !== undefined) {
        return sectionData[key].data;
    }
    return "-";
};

const DashboardCard = ({titleId, titleDefault, fields, sectionKey, widgetDataMap}) => (
    <Box type="outline" spacingInset="none" overflowX="auto">
        <Column spacing="none">
            <div style={HEADER_STYLE}>
                <Box spacingInset="small medium">
                    <Text type="h300" color="inverted">
                        <FormattedMessage id={titleId} defaultMessage={titleDefault}/>
                    </Text>
                </Box>
            </div>
            {fields.map((field) => (
                <Row key={field.key} spacingInset="small medium" alignmentHorizontal="justify">
                    <Text type="b200">
                        <FormattedMessage id={field.labelId} defaultMessage={field.labelDefault}/>
                    </Text>
                    <Text type="b500">{getValue(widgetDataMap, sectionKey, field.key)}</Text>
                </Row>
            ))}
            {Array.from({length: MAX_ROWS - fields.length}).map((_, i) => (
                <Row key={`empty-${i}`} spacingInset="small medium" alignmentHorizontal="justify">
                    <Text type="b200">{"\u00A0"}</Text>
                    <Text type="b500">{"\u00A0"}</Text>
                </Row>
            ))}
        </Column>
    </Box>
);

const QCDashboardDataUI = ({widgetDataMap, isLoading}) => {
    return (
        <Column spacing="medium" spacingInset="medium">
            <Column spacing="none">
                <Heading level={2} type="h400">
                    <FormattedMessage id="qcDashboard.heading" defaultMessage="Dwell"/>
                </Heading>
                <Text color="secondary">
                    <FormattedMessage id="qcDashboard.description" defaultMessage="QC orders (real-time status and tracking)"/>
                </Text>
            </Column>
            {isLoading ? <Loader type="linear" size="small"/> :
                <Row widths={["grid-4", "grid-4", "grid-4"]} alignmentVertical="top" spacing="medium">
                    {Object.entries(SECTIONS).map(([sectionKey, section]) => (
                        <DashboardCard
                            key={sectionKey}
                            titleId={section.titleId}
                            titleDefault={section.titleDefault}
                            fields={section.fields}
                            sectionKey={sectionKey}
                            widgetDataMap={widgetDataMap}
                        />
                    ))}
                </Row>
            }
        </Column>
    );
};

export default QCDashboardDataUI;



// WEBPACK FOOTER //
// ./src/components/qcDashboard/QCDashboardDataUI.js